import { LOCAL_COMPANY_BYPASS } from "utils/globalConstantsAndURL";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { t } from "i18next";

import ItemSidenav from "../ItemSidenav/ItemSidenav";
import ItemDropdownSidenav from "../ItemDropdownSidenav/ItemDropdownSidenav";

import acceuilImg from "../assets/Acceuil.png";
import contractImg from "../assets/Contract.png";
import ficheInfoImg from "../assets/Fiche_Info.png";
import studentImg from "../assets/Student.svg";
import depotOffreImg from "../assets/Depot_Offre.png";

const SidenavENTContent = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const username = instance.getActiveAccount()?.username;

  return (
    <>
      {!isAuthenticated && !LOCAL_COMPANY_BYPASS && (
        <ItemSidenav name={t("app.horizontalNavLogIn.PageAccueil")} img={acceuilImg} path="/" />
      )}
      {(isAuthenticated || LOCAL_COMPANY_BYPASS) && (
        <ItemSidenav name={t("app.horizontalNavLogIn.PageAccueil")} img={acceuilImg} path="/" />
      )}
      {(isAuthenticated || LOCAL_COMPANY_BYPASS) && (
        <ItemSidenav
          name={t("app.horizontalNavLogIn.MatchUpOffresCV")}
          img={depotOffreImg}
          blankURL={`${process.env.REACT_APP_MATCHUP_REDIRECT_URI}/company${username ? `?user=${username}` : ""}`}
        />
      )}

      {(isAuthenticated || LOCAL_COMPANY_BYPASS) && (
        <ItemSidenav name={t("app.horizontalNavLogIn.FicheEntreprise")} img={ficheInfoImg} path="/fiche-entreprise" />
      )}

      {(isAuthenticated || LOCAL_COMPANY_BYPASS) && (
        <ItemDropdownSidenav
          name={t("app.horizontalNavLogIn.SuivezContratsMenu")}
          img={contractImg}
          liList={[
            {
              name: t("app.horizontalNavLogIn.SuivezVosContrats"),
              path: "suivez-vos-contrats",
              liImg: contractImg,
            },
            // {
            //   name: t("app.horizontalNavLogIn.ConventionDeStage"),
            //   path: "conventions-de-stage",
            //   liImg: contractImg,
            // },
          ]}
        />
      )}

      {(isAuthenticated || LOCAL_COMPANY_BYPASS) && (
        <ItemSidenav
          name={t("app.horizontalNavLogIn.AccompagnezVosAlternants")}
          img={studentImg}
          path="/suivez-vos-alternants"
        />
      )}
    </>
  );
};

export default SidenavENTContent;
